namespace GeniuzPOS.PosShift {
    export interface ListByDocNoRequest extends Serenity.ServiceRequest {
        DocNo?: string;
    }
}
